<template>
  <div>
    <page-table ref="pageTable" :init-fetch="true" :loading="tableLoading" :columns="tableColumns"
                :page-total="pageTotal" :table-data="tableData" :show-create-btn="false"
                @fetchData="fetchData">
      <template slot="searchForm">
        <FormItem class="margin-bottom-0">
          <Input v-model="params.keywords" placeholder="用户名/订单编号" style="width: 260px"></Input>
        </FormItem>
        <FormItem class="margin-bottom-0">
          <DatePicker v-model="params.paid_at" type="datetimerange" placement="bottom-end" placeholder="支付时间"
                      style="width: 330px"></DatePicker>
        </FormItem>
      </template>

      <template slot="avatar" slot-scope="{ row }">
        <Avatar :src="row.avatar"></Avatar>
      </template>
      <template slot="status" slot-scope="{ row }">
        <Tag checkable color="primary" v-if="row.status === 0">已下单未支付</Tag>
        <Tag checkable color="success" v-if="row.status === 1">已支付</Tag>
        <Tag checkable color="warning" v-if="row.status === 2">取消支付</Tag>
        <Tag checkable color="error" v-if="row.status === 3">支付失败</Tag>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Tooltip content="详情" placement="top" transfer>
          <Button type="primary" size="small" icon="md-eye" style="margin-right: 5px" @click="btnHandler('detail', row)" />
        </Tooltip>
      </template>
    </page-table>
    <Drawer v-model="detailDrawer.show" :title="detailDrawer.title"  :mask-closable="false" width="1000">
      <order-detail :id="detailDrawer.id"></order-detail>
    </Drawer>
  </div>
</template>

<script>
import pageTable from '../../components/pageTable/index'
import { getOrderList } from '../../api/order'
import OrderDetail from './components/order-dateil'

export default {
  name: 'order-list',
  components: { OrderDetail, pageTable },
  data () {
    return {
      params: {
        keywords: '',
        paid_at: []
      },
      tableLoading: false,
      tableData: [],
      pageTotal: 0,
      detailDrawer: {
        show: false,
        title: '',
        id: ''
      }
    }
  },
  computed: {
    tableColumns () {
      return [
        { title: '订单编号', key: 'order_no', width: 150 },
        { title: '头像', key: 'avatar', slot: 'avatar', width: 60 },
        { title: '用户名', key: 'nickname', width: 160 },
        { title: '活动标题', key: 'title', tooltip: true },
        { title: '支付金额', key: 'total_fee', align: 'center', width: 80 },
        { title: '订单状态', key: 'status', align: 'center', width: 110, slot: 'status' },
        { title: '支付时间', key: 'paid_at', align: 'center', width: 150 },
        { title: '创建时间', key: 'create_time', tooltip: true, width: 150 },
        { title: '操作', slot: 'action', width: 80, align: 'center', fixed: 'right' }
      ]
    }
  },
  methods: {
    fetchData (page) {
      this.tableLoading = true
      const params = { ...this.params, ...page }
      getOrderList(params).then(({ data }) => {
        this.tableData = data.data
        this.pageTotal = data.total
      }).finally(() => {
        this.tableLoading = false
      })
    },
    btnHandler (e, row) {
      this[e](row)
    },
    detail (row) {
      this.detailDrawer.show = true
      this.detailDrawer.title = row.order_no + '-订单详情'
      this.detailDrawer.id = row.order_no
    }
  }
}
</script>

<style scoped>

</style>
